module.exports = __webpack_public_path__ + "static/media/chevron-down.0ca3bf63.svg";